import React, { ReactNode, useState } from 'react'
import { NavLink } from 'react-router-dom'

interface LayoutProps {
  children: ReactNode
}

const navigation = [
  { name: 'Dashboard', href: '/' },
  { name: 'Asset Evaluation', href: '/asset-evaluation' },
  { name: 'Conviction Scoring', href: '/conviction-scoring' },
  { name: 'Quantum Learning Curve', href: '/quantum-learning-curve' },
  { name: 'Hostile Acquisition', href: '/hostile-acquisition' },
  { name: 'Knowledge Base', href: '/knowledge-base' },
]

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div 
      style={{
        display: 'grid',
        gridTemplateColumns: '224px 1fr',
        gridTemplateRows: '1fr',
        gridTemplateAreas: '"sidebar main"',
        height: '100vh',
        width: '100vw',
        maxWidth: 'none',
        margin: 0,
        padding: 0,
        overflowX: 'hidden'
      }}
      className="bg-gray-50"
    >
      {/* Sidebar */}
      <div 
        style={{
          gridArea: 'sidebar',
          width: '224px',
          height: '100vh',
          position: 'relative',
          zIndex: 50
        }}
        className={`bg-white shadow-lg transform ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 ease-in-out lg:translate-x-0`}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
            <div className="flex flex-col items-center w-full">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-lg">S</span>
                </div>
                <span className="ml-2 text-xl font-bold text-gray-900">StratOS</span>
              </div>
              <span className="text-xs text-gray-500 mt-1">Investment Intelligence Platform</span>
            </div>
            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden text-gray-400 hover:text-gray-500 absolute right-6"
            >
              ✕
            </button>
          </div>
          
          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-2">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) => 
                  `block px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                    isActive
                      ? 'bg-blue-100 text-blue-700 border-r-2 border-blue-600'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>
          
          {/* Footer */}
          <div className="p-4 border-t border-gray-200">
            <div className="text-xs text-gray-500">
              StratOS v1.0.0
            </div>
          </div>
        </div>
      </div>

      {/* Main Content - No Header, Maximum Space */}
      <main 
        style={{
          gridArea: 'main',
          width: '100%',
          maxWidth: 'none',
          margin: 0,
          padding: '1.5rem',
          overflowY: 'auto',
          height: '100%'
        }}
      >
        {/* Mobile menu button - positioned absolutely when needed */}
        <button
          onClick={() => setSidebarOpen(true)}
          className="lg:hidden fixed top-4 left-4 z-10 bg-white rounded-md p-2 text-gray-400 hover:text-gray-500 shadow-md"
        >
          ☰
        </button>
        
        {children}
      </main>
    </div>
  )
}